/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// uploadPdfAndImage
// UPLOADPDFANDIMAGE
const GETUSERBYID= createAsyncThunk(
  "getUserById/getUserById",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getUserByIdSlice = createSlice({
  name: "getUserByIdSlice",
  initialState: {
    getUserById: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetUserById: (state) => {
        state.getUserById.loading = false
        state.getUserById.error = false
        state.getUserById.data = []
        state.getUserById.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETUSERBYID.fulfilled, (state, action) => {
      state.getUserById = {
        ...state.getUserById,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETUSERBYID.pending, (state, action) => {
      state.getUserById = {
        ...state.getUserById,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETUSERBYID.rejected, (state, action) => {
      state.getUserById = {
        ...state.getUserById,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getUserByIdAction = {
    GETUSERBYID,
};

export { getUserByIdAction };
export default getUserByIdSlice.reducer;
export const {setInitialStateOfgetUserById} = getUserByIdSlice.actions